import { FC, useCallback } from 'react';
import classes from '../../asset/css/subscription-detail/header.module.css';

export const Header: FC<{ btnFunc: () => void }> = ({ btnFunc }) => {
  const btnEventHandler = useCallback(() => {
    btnFunc();
  }, [btnFunc]);

  return (
    <>
      <div className={classes.mypage_subsc_header}>
        <h3 className={classes.mypage_subsc_title}>
          あなたの
          <br />
          毎月お届けプラン
        </h3>
        <button className={classes.mypage_subsc_config} onClick={btnEventHandler}>
          <p>
            お届け日
            <br />
            サイクル
          </p>
          <div>変更</div>
        </button>
      </div>
    </>
  );
};
